import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { SobreviventeCreatePage } from '@/features/sobrevivente/components/SobreviventeCreatePage'

export const Route = createFileRoute('/_authenticated/sobrevivente/new')({
  component: SobreviventeNew,
})

function SobreviventeNew() {
  return (
    <>
      <AppHeader title="Novo Jogo de Sobrevivente" />
      <SobreviventeCreatePage />
    </>
  )
}
